import { configureStore, createSlice } from '@reduxjs/toolkit';

const initialSermonState = {allSermons: [], filteredSermons: [], filterText: null};

const sermonSlice = createSlice({
    name: "sermons",
    initialState: initialSermonState,
    reducers: {
        setAllSermons(state, action) {
            state.allSermons = action.payload;
            state.filteredSermons = action.payload;
            state.filterText = null;
        },
        filterSermons(state, action) {
            if (state.allSermons === null || state.allSermons.length === 0) {
                console.log("Filter Sermons reducer - no sermons loaded yet");
                return;
            }
            state.filterText = action.payload;
            if (state.filterText && state.filterText.length > 2) {
                state.filteredSermons = state.allSermons.filter(sermon => {
                    if (sermon.speaker.toUpperCase().indexOf(state.filterText.toUpperCase()) >= 0) {
                        return true;
                    } else if (sermon.tagLine.toUpperCase().indexOf(state.filterText.toUpperCase()) >= 0) {
                        return true;
                    } else if (sermon.scripture.toUpperCase().indexOf(state.filterText.toUpperCase()) >= 0) {
                        return true;
                    }
                    return false;
                });
                console.log("There are " + state.filteredSermons.length + " sermons matching " + state.filterText);
            } else {
                state.filteredSermons = state.allSermons;
            }
        }
    }
});

const store = configureStore({
    reducer: sermonSlice.reducer
});

export const sermonActions = sermonSlice.actions;
export default store;